import { observer } from "mobx-react-lite"

import { ShowWhenTrue } from "@/components/conditionals"
import { DisplayTokenTableValues } from "@/components/display-token-values"
import { dollarsPrettified } from "@/domains/library"

import { ILiquidityPool } from "../types"

export const TvlColumn = observer(({ pool, isCompact }: { pool: ILiquidityPool; isCompact: boolean }) => {
  if (!pool) {
    return <p className="text-t100">{dollarsPrettified(0)}</p>
  }

  return (
    <div className="space-y-1">
      <p className="text-t100">{dollarsPrettified(pool.tvlUsd)}</p>
      <ShowWhenTrue when={isCompact === false}>
        <DisplayTokenTableValues tokens={pool.tokens} values={pool.reserves} />
      </ShowWhenTrue>
    </div>
  )
})
